import { Colors } from "src/com/sixdee/crbtportal/utils/resources/colors";
import { Fonts } from "src/com/sixdee/crbtportal/utils/resources/fonts";
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from "../../../../toolkit/uicomponentcss";

export interface SetFlashMessageCSSStyle extends UIComponentCSSStyle
{
    getContentDivCSSStyle():object;
    getContentLabel1CSSStyle():object;
    getContentLabel2CSSStyle():object;
    getSubcriptionDivCSSStyle():object;
    getConfirmButtonCSSStyle(): object;
    getTermsConditionCSSStyle(): object;
    getMobileCloseIconCSSStyle(): object ;
    getCloseIconDivCSSStyle(): object;
    getCloseIconCSSStyle(): object ;
    getRowDivCSSStyle():object;
    getMobileNumberCSSStyle(): object ;
    getMobileConfirmButtonCSSStyle():object;
    getAnchorCSSStyle(): object;
    getHeaderDivCSSStyle(): object ;
    getTitleCSSStyle(): object ;

}

export class SetFlashMessageCSSStyleImpl extends UIComponentCSSStyleImpl implements SetFlashMessageCSSStyle
{
    
    getHeaderDivCSSStyle(): object 
    {
        return {
            backgroundColor: this.getResources().getColor(Colors.color_18),
            width: "100%",
            height: "60px",
            display: "flex",
            borderRadius: "8px 8px 0px 0px",
        };
    }
    getTitleCSSStyle(): object {
        return {
            width: "380px",
            height: "40px",
            fontWeight: "300",
            letterSpacing: 0,
            paddingLeft: "40px",
            paddingRight: "0px",
            fontSize: this.getResources().getFont(Fonts.h12),
            color:this.getResources().getColor(Colors.color_19),
            lineHeight: "40px",
            marginTop: "7px",
            textAlign: "center"
        };
    }

    getCloseIconDivCSSStyle(): object 
    {
        return {
            height: "60px",
            width: "60px",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            display: "inline-block",
            cursor: "pointer"
        };
    }

    getCloseIconCSSStyle(): object 
    {
        return {
            height: "12px",
            width: "12px",
            marginTop: "22px",
            cursor: "pointer"
        };
    }

    getMobileCloseIconCSSStyle(): object 
    {
        return {
            height: "12px",
            width: "12px",
            marginRight: "10px",
            marginTop: "22px",
            cursor: "pointer"
        };
    }

    getMobileNumberCSSStyle(): object 
    {
        return {
            marginTop: "40px",
            marginLeft:'31.5px',
            marginRight:'31.5px'
        };
    }
    getWrapperCSSStyle(): object
    {
        return {
            height: "auto",
            width: "100%",
            borderRadius: "8px",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            paddingBottom:'30px'

        };
    }
    

    getRowDivCSSStyle(): object 
    {
        return {
            marginTop: "20px",
            display: "flex",
            width:'100%',
            justifyContent:'center',
            position: "relative",
            alignItems:'center',
            flexDirection:"row",
            flexFlow: "row wrap",
        };
    }
    getContentDivCSSStyle(): object 
    {
        return{
            width:'227px',
            margin:'0px 106.5px 18px 106.5px',
            height:'60px',
            textAlign:'center' 
        };
    }
    getTermsConditionCSSStyle(): object {
        return{
            display: "inline-block",
            // textAlign: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "left" : "right",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h7),
            color:'#231F20',
            fontWeight:'500',
            fontFamily:this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingLeft: "10px",
            // flex: 2,
            // paddingTop:'5px',
            // marginLeft:'5px',
        };
    }

    getContentLabel1CSSStyle(): object 
    {
        return{
            color:this.getResources().getColor(Colors.color_19),
            fontSize:this.getResources().getFont(Fonts.h9),
            textAlign:'center',
            lineHeight:'10px'
        };
    }

    getContentLabel2CSSStyle(): object 
    {
        return{
            color:this.getResources().getColor(Colors.color_21), 
            fontSize:this.getResources().getFont(Fonts.h10),
            textAlign:'center',
            fontWeight:500,
        lineHeight:'20px'
        };
    }

    getSubcriptionDivCSSStyle(): object 
    {
        return{
            width:"345px",
            color:this.getResources().getColor(Colors.color_22),
            fontFamily: this.getResources().getFontFamily(),
            margin:"0px 47.5px 0px 47.5px",
            fontSize:this.getResources().getFont(Fonts.h9), 
            fontWeight:500 ,
            height:'20px',
            lineHeight:'20px', 
            letterSpacing:'0',
            textAlign:'center'
        };
    }

    getConfirmButtonCSSStyle(): object 
    {
        return {
            marginTop: "30px",
            width:'180px',
            height: "40px",
            marginLeft: "auto",
            marginRight: "auto",
        };
    }

    getMobileConfirmButtonCSSStyle():object
    {
        return {
            marginTop: "30px",
            width:'100px',
            height: "40px",
            marginLeft: "auto",
            marginRight: "auto",
        };
    }
    getAnchorCSSStyle(): object {
        return {
                    lineHeight: '20px', 
                    letterSpacing: "-0.08px",
                    fontFamily: this.getResources().getFontFamily(), 
                    fontSize: this.getResources().getFont(Fonts.h6), 
                    color: this.getResources().getColor(Colors.color_7), 
                };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/setflashmessage/setflashmessagecss.tsx